/* tslint:disable */
/* eslint-disable */
/**
 * Flight Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CabinClassRequest = {
    All: 'All',
    Economy: 'Economy',
    Business: 'Business',
    FirstClass: 'FirstClass',
    Unknown: 'Unknown',
    EconomyPlus: 'EconomyPlus',
    PremiumEconomy: 'PremiumEconomy',
    PremiumBusiness: 'PremiumBusiness',
    BusinessComfort: 'BusinessComfort',
    PremiumFirstClass: 'PremiumFirstClass'
} as const;

export type CabinClassRequest = typeof CabinClassRequest[keyof typeof CabinClassRequest];



